import Axios from "axios";
import useSWRV from "swrv";
import { computed } from "@vue/composition-api";

export default function use(key, fetcher, options) {
  if (!fetcher) {
    fetcher = (url) => Axios(url).then((res) => res.data);
  }
  if (!options) {
    options = {};
  }
  if (!options.shouldRetryOnError) {
    options.shouldRetryOnError = false;
  }
  if (!options.revalidateOnFocus) {
    options.revalidateOnFocus = false;
  }
  if (!options.dedupingInterval) {
    options.dedupingInterval = 5000;
  }
  const swr = useSWRV(key, fetcher, options);
  return {
    ...swr,
    isLoading: swr.isValidating,
    isLoaded: computed(() => swr.data.value !== undefined),
    reload: () => swr.mutate(),
  };
}
